module.exports = __webpack_public_path__ + "static/media/wind.67f70c3f.svg";